import React from 'react';
import { motion } from 'framer-motion';
interface ThreadsProps {
  className?: string;
  count?: number;
  color?: string;
}
export function Threads({
  className = '',
  count = 6,
  color = 'rgba(26,143,212,0.3)'
}: ThreadsProps) {
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-256">
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 1000" preserveAspectRatio="none" data-id="element-257">
        {Array.from({
        length: count
      }).map((_, i) => {
        const baseY = 50 + i * (900 / count);
        return <motion.path key={i} fill="none" stroke={color} strokeWidth="1" initial={{
          d: `M0,${baseY} Q250,${baseY} 500,${baseY} T1000,${baseY}`
        }} animate={{
          d: [`M0,${baseY} Q250,${baseY - 40} 500,${baseY} T1000,${baseY - 30}`, `M0,${baseY} Q250,${baseY + 40} 500,${baseY} T1000,${baseY + 30}`, `M0,${baseY} Q250,${baseY - 40} 500,${baseY} T1000,${baseY - 30}`]
        }} transition={{
          duration: 8 + i,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-258" />;
      })}
      </svg>
    </div>;
}